import {Component} from 'ng-metadata/core';

@Component({
    selector: 'prm-newspapers-full-view',
    templateUrl: 'components/newspapers/newspapersFullView/newspapers-full-view.html',
})

export class PrmNewspapersFullView{
    constructor() {
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapersFullView/newspapersFullView.directive.ts